import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import Link from "next/link";
import styles from './sales.module.css';

type Props = {
    title: string,
    content: string[] | string,
    price: string,
    abovePrice: boolean,
    includeButton: boolean
}

const SingleListing = ({ title, content, price, abovePrice = true, includeButton = true }: Props) => (
    <div className={styles.SingleListing}>
        <div className={styles.PricingHeader}>
            {title}
        </div>
        <div className={abovePrice ? styles.divider: styles.displayNone} />
        <h3 className="PopularPricing">{price}</h3>
        <div className={!abovePrice ? styles.divider: styles.displayNone} />
        {Array.isArray(content) && <ul>
            {content.map((para, index) => {
                return <li key={index}><CheckCircleOutlineRoundedIcon />{para}</li>
            })}
        </ul>}

        {typeof content === 'string' && 
            <p className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
        }

        {includeButton && (
            <button className={styles.contactButton}><Link prefetch={false} href="/sales/single-property">Buy now</Link></button>
        )}

    </div>

);

export default SingleListing;